import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';

import { ConversionTableSorting } from '../../../../types';
import { CONVERSION_TABLE_DEFAULT_SORTING } from '../../../../constants';
import { useLenderPerformanceConversionFunnel } from '../../../../hooks/useLenderPerformanceConversionFunnel';

import { KeyRatioCards } from './KeyRatioCards';
import { PipelineFunnelCard } from './PipelineFunnelCard';
import { LenderConversionTable } from './LenderConversionTable';
import { LookToBookByLenderChart } from './LookToBookByLenderChart';
import { MonthlyLookToBookChart } from './MonthlyLookToBookChart';
import { MonthlyLookToBookByLenderChart } from './MonthlyLookToBookByLenderChart';

interface Props {
  input: LenderPerformanceReportInput;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const ConversionFunnel = ({ input, onLoadingChange }: Props) => {
  const [sorting, setSorting] = useState<ConversionTableSorting>(CONVERSION_TABLE_DEFAULT_SORTING);

  const { ratioCards, funnel, conversionTable, trend, trendByLender, isLoading } = useLenderPerformanceConversionFunnel(
    input,
    sorting
  );

  useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  return (
    <Stack gap="0.5rem">
      <KeyRatioCards ratioCards={ratioCards.data} filters={input.filters} loading={ratioCards.loading} />

      <PipelineFunnelCard funnel={funnel.data} loading={funnel.loading} />

      <Box data-pdf-page-break>
        <LenderConversionTable resource={conversionTable} sorting={sorting} onSortingChange={setSorting} />
      </Box>

      <Box data-pdf-no-break>
        <LookToBookByLenderChart resource={conversionTable} filters={input.filters} />
      </Box>

      <Box data-pdf-no-break>
        <MonthlyLookToBookByLenderChart resource={trendByLender} filters={input.filters} />
      </Box>

      <Box data-pdf-no-break>
        <MonthlyLookToBookChart resource={trend} />
      </Box>
    </Stack>
  );
};
